import * as React from 'react';
import type { CheckboxesConfig } from './types';

type ContextState = {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  checkboxesConfig: CheckboxesConfig;
  selectedCheckboxValues: string[];
  setSelectedCheckboxValues: React.Dispatch<React.SetStateAction<string[]>>
  resetSelectedCheckboxValues: () => void;
}

export const PageHeaderWithFiltersContext = React.createContext<ContextState>({} as ContextState);